import { render, staticRenderFns } from "./AudioUploaderNew.vue?vue&type=template&id=5148b01f&"
import script from "./AudioUploaderNew.vue?vue&type=script&lang=js&"
export * from "./AudioUploaderNew.vue?vue&type=script&lang=js&"
import style0 from "./AudioUploaderNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports